import { computed } from 'vue';
import { useAanbodDefinitieByVersionQuery } from '@/use/aanbod-definitie/use-aanbod-definitie-by-version-query';
import { useAanbodDefinitieQuery } from '@/use/aanbod-definitie/use-aanbod-definitie-query';
import { useRouteExtensions } from '@/use/use-route-extensions';
import { unref } from 'vue';
import { useLeadAanvraagStore } from '@/stores/lead-aanvraag/lead-aanvraag';

export const useAanbodExtensions = (getAanbodDefinitieByNaam) => {
  const { lang, aanbodNaam, subflowNaam, pageNaam } = useRouteExtensions();
  const leadAanvraagStore = useLeadAanvraagStore();
  const aanbodVersieId = computed(() => leadAanvraagStore.leadAanvraag?.aanbodVersieId);
  const subflowVersieIds = computed(() => leadAanvraagStore.subflowVersieIds);

  const {
    data: aanbodDefinitie,
    isLoading,
    homeButtonAvailable
  } = getAanbodDefinitieByNaam
    ? useAanbodDefinitieQuery(lang, aanbodNaam)
    : useAanbodDefinitieByVersionQuery(aanbodVersieId, subflowVersieIds, lang);

  const showPartnerIcon = computed(() => {
    return aanbodDefinitie?.value && aanbodDefinitie?.value.partnerIcon ? true : false;
  });

  const getPartnerIcon = computed(() => {
    return aanbodDefinitie?.value ? aanbodDefinitie?.value.partnerIcon : undefined;
  });

  const currentPageConfig = computed(() => {
    return getPageConfigFromAanbod(aanbodDefinitie, subflowNaam, pageNaam);
  });

  const currentSubflow = computed(() => {
    return aanbodDefinitie?.value?.subflows.find((sf) => sf.naam === subflowNaam.value);
  });

  function getPageConfigFromAanbod(aanbodDefinitieFromParam, subflowNaam, pageNaam) {
    const subflowConfig = getSubflowConfigFromAanbod(aanbodDefinitieFromParam, subflowNaam);
    const pageConfig = subflowConfig?.pages?.find((page) => page.naam === unref(pageNaam));
    return pageConfig;
  }

  function getSubflowConfigFromAanbod(aanbodDefinitieFromParam, subflowNaam) {
    return aanbodDefinitieFromParam?.value?.subflows?.find(
      (subflow) => subflow.naam === unref(subflowNaam)
    );
  }

  const pageHasMultipleStappen = computed(() => {
    return currentPageConfig?.value?.stappen.length > 1;
  });

  const subflowVersies = computed(() => {
    return aanbodDefinitie?.value?.subflows?.map((s) => {
      return { subflowId: s.subflowId, subflowVersieId: s.subflowVersieId, dienstId: s.dienstId };
    });
  });

  return {
    aanbodDefinitie,
    homeButtonAvailable,
    isLoading,
    showPartnerIcon,
    getPartnerIcon,
    currentSubflow,
    currentPageConfig,
    pageHasMultipleStappen,
    subflowVersies
  };
};
